import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useSearchParams } from 'next/navigation';
import { selectRsvp, setRsvp, restore as clear } from './rsvp.slice';
import { useLazyGetRsvpApiQuery } from './rsvp.api';

const useRsvp = () => {
  const {
    event: { use_seats },
  } = useSelector((state) => state.event || { event: {} });
  const searchParams = useSearchParams();
  const rsvpLink = searchParams.get('link');

  const dispatch = useDispatch();
  const [trigger] = useLazyGetRsvpApiQuery();
  const rsvp = useSelector(selectRsvp);
  const [seatsAvailables, setSeatsAvailables] = useState([]);

  const loadRsvp = async (eventId) => {
    if (rsvpLink) {
      const { data } = await trigger({ eventId, link: rsvpLink });
      if (data) {
        dispatch(setRsvp({ ...data, id: rsvpLink }));
      }
    } else {
      restore();
    }
  };

  const restore = () => {
    dispatch(setRsvp({}));
  };

  useEffect(() => {
    if (
      use_seats &&
      rsvp &&
      !isEmpty(rsvp) &&
      rsvpLink &&
      rsvp.type === 'hold'
    ) {
      setSeatsAvailables(
        rsvp.detail.map(
          ({ section, row, seat }) =>
            `${section}${row ? '-' : ''}${row}${seat ? '-' : ''}${seat}`,
        ),
      );
    }
  }, [rsvp, use_seats]);

  return {
    rsvp: rsvp && !isEmpty(rsvp) && rsvpLink ? rsvp : null,
    loadRsvp,
    restore,
    isActive: rsvpLink && rsvp && rsvp.is_active,
    isRsvp: !!rsvpLink,
    isRsvpExpired: rsvpLink && rsvp && !rsvp.is_active,
    seatsAvailables,
    rsvpLink,
    rsvpStored: rsvp,
  };
};

export default useRsvp;
